import theme from "./theme"
import socket from "./socket"
import inputs from "./inputs"
import table from "./table"
import apis from "./apis"
export default {
    theme,
    socket,
    inputs,
    table,
    // inputs,
    apis
}